import {FC} from "react";
import IconLifecycle from "../../../../assets/icons/filters/icon-zigzag-arrow.svg";
import {ChartEntryButton} from "./ChartEntryButton";

interface IProps {
  openCharts: () => void;
}

export const GartnerCharts: FC<IProps> = ({openCharts}) => (
  <ChartEntryButton
    icon={IconLifecycle}
    label="Жизненный цикл технологии"
    onClick={openCharts}
  />
);
